export const BUTTON_LINK = 'js-button-link';
export const ADD_TO_CART_BUTTON = 'js-add-to-cart-button';
export const ONE_CLICK_CHECKOUT_BUTTON = 'js-one-click-checkout';
export const INPUT = '.js-text-input';
export const INPUT_ERROR_MESSAGE_CLASS = 'input__error-message';
export const INPUT_ERROR_CLASS = 'input--error';
export const SELECT = 'select';
export const HIDDEN = 'hidden';
export const EXPANDED = 'expanded';
export const INVALID = 'invalid';
export const SAMPLE = 'sample';
export const DISABLED = 'disabled';
export const ACTIVE = 'active';
export const IMAGE_WRAPPER = 'image__wrapper';
export const IMAGE_CONTAINER = 'image__container';
export const BUTTON_DISABLED = 'btn--disabled';
export const NO_SCROLL_CLASS_NAME = 'no-scroll';
